export default __webpack_public_path__ + "5ddab8ce9672e87053844d6101716d7d.jpg";